import { ofType } from "redux-observable";
import { switchMap, ignoreElements } from "rxjs/operators";
import Types from "../actions/types";
import { markServiceWorkerUpdatePending } from "../../../client-bootstrap";

export const updateEffect = (action$) =>
	action$.pipe(
		ofType(Types.NOTIFICATIONS_UPDATE_APPLIED),
		switchMap(() => {
			// For development testing
			if (process.env.NODE_ENV === "development" && window.fakeServiceWorkerRegistration) {
				markServiceWorkerUpdatePending();
				window.fakeServiceWorkerRegistration.waiting.postMessage({ type: "SKIP_WAITING" });
				return [];
			}

			const performUpdate = async () => {
				console.log("Attempting to update the application...");

				try {
					localStorage.setItem("app_updating", "true");
					localStorage.setItem("app_update_time", Date.now().toString());
					markServiceWorkerUpdatePending();

					if ("serviceWorker" in navigator) {
						if (window.__ftrWaitingServiceWorker) {
							window.__ftrWaitingServiceWorker.postMessage({ type: "SKIP_WAITING" });
							window.__ftrWaitingServiceWorker = null;
						}

						const registrations = await navigator.serviceWorker.getRegistrations();
						for (const registration of registrations) {
							await registration.update();
							if (registration.waiting) {
								markServiceWorkerUpdatePending();
								registration.waiting.postMessage({ type: "SKIP_WAITING" });
							}
						}
					}

					// If no waiting worker activated (controllerchange won't fire), reload once.
					setTimeout(() => {
						if (window.__ftrSwUpdatePending) {
							window.__ftrSwUpdatePending = false;
							window.location.reload();
						}
					}, 1000);
				} catch (err) {
					console.error("Error during update process:", err);
					window.__ftrSwUpdatePending = false;
					window.location.reload();
				}
			};

			performUpdate();
			return [];
		}),
		ignoreElements()
	);
